<template>
  <user-center-slot>
    <user-center-container-slot>
        <!-- 左侧菜单栏 -->
        <user-center-menu />

        <user-center-content-slot :hidden="true"> 
          <user-center-content-title title="身份认证" />
          <div class="user-center__id-row">
             <div class="user-center__id-summary">
              <i class="iconfont icon-_biaodan user-center__id-icon--default"></i>
              <span class="user-center__id-tips">认证身份信息，更好的为您服务</span>
             </div>
              <div>
                <a v-show="editFlag" class="user-center__id-button--primary" href="javascript:void(0);" @click="onEdit">修改资料</a>
              </div>
          </div>
          <div class="user-center__id-tips--friendly">
          温馨提示：建议您在收到漏洞奖金支付消息通知时，及时完善您的身份认证资料，该信息用于您的漏洞奖金支付，如下的信息我们将按照法律要求和业界成熟的安全标准，为您的个人信息提供相应的安全保护措施！
          </div>
          <!-- 展示部分 -->
          <div v-if="isEdit">
              <div class="user-center__id-list">
                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">真实姓名:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.realName }}</div>
                </div>

                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">手机号码:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.phoneNumber }}</div>
                </div>

                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">身份证号:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.idCard }}</div>
                </div>

                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">银行名称:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.bank }}</div>
                </div>

                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">开户银行:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.bankName }}</div>
                </div>

                <div class="user-center__id-item is-overflow-hidden">
                  <div class="user-center__id-item-title">银行卡号:</div>
                  <div class="user-center__id-item-content is-overflow-hidden">{{ ruleForm.bankCard }}</div>
                </div>
              </div>
          </div>

          <!-- 编辑部分 -->
          <div v-if="!isEdit">
            <div>
              <xui-form ref="ruleForm" class="user-center__id-list" :model="ruleForm" :rules="rules">
                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">真实姓名:</div>
                  <div class="user-center__id-item-content">
                    <xui-form-item prop="realName">
                      <xui-input v-model.trim="ruleForm.realName" placeholder="请输入您的真实姓名"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">手机号码:</div>
                  <div class="user-center__id-item-content">
                     <xui-form-item prop="phoneNumber">
                      <xui-input v-model.trim="ruleForm.phoneNumber" placeholder="请输入您的手机号"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">身份证号:</div>
                  <div class="user-center__id-item-content">
                       <xui-form-item prop="idCard">
                      <xui-input v-model.trim="ruleForm.idCard" placeholder="请输入您的身份证号码"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">银行名称:</div>
                  <div class="user-center__id-item-content">
                    <xui-form-item prop="bank">
                      <xui-input v-model.trim="ruleForm.bank" placeholder="请输入您的银行名称"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">开户银行:</div>
                  <div class="user-center__id-item-content">
                    <xui-form-item prop="bankName">
                      <xui-input v-model.trim="ruleForm.bankName" placeholder="请输入您的开户银行"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">银行卡号:</div>
                  <div class="user-center__id-item-content">
                     <xui-form-item prop="bankCard">
                      <xui-input v-model.trim="ruleForm.bankCard" placeholder="请输入您的银行卡号"></xui-input>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">身份证正面:</div>
                  <div class="user-center__id-item-content">
                    <xui-form-item prop="idCardFrontId">
                      <xui-upload
                        class="idCard_upload"
                        :before-upload="beforUploadPic"
                        action="idCardFrontId"
                        :on-error="reportError"
                        :before-remove="triggerRemove"
                        :http-request="uploadImg"
                        list-type="picture-avatar"
                        :headers="xCsrfToken"
                        :on-success="handlePreview"
                        :with-credentials="true"
                      >
                        <span style="width:100px;height:100px;">{{ ruleForm && ruleForm.idCardFrontId ? '请修改身份证头像面' : '请上传身份证头像面' }}</span>
                        <!-- <img v-if="ruleForm.idCardPhotoFont" :src="'data:image/jpeg;base64' + ruleForm.idCardPhotoFont" style="max-width:100%;max-height:100%;" /> -->
                      </xui-upload>
                    </xui-form-item>
                  </div>
                </div>

                <div class="user-center__id-item">
                  <div class="user-center__id-item-title is-required">身份证反面：</div>
                  <div class="user-center__id-item-content">
                      <xui-form-item prop="idCardBackId">
                        <xui-upload
                          class="idCard_upload"
                          :before-upload="beforUploadPic"
                          action="idCardBackId"
                          :on-error="reportError"
                          :before-remove="triggerRemove"
                          :http-request="uploadImg"
                          list-type="picture-avatar"
                          :headers="xCsrfToken"
                          :on-success="handlePreview"
                          :with-credentials="true"
                        >
                          <span style="width:100px;height:100px;">{{ ruleForm && ruleForm.idCardBackId ? '请修改身份证国徽面' : '请上传身份证国徽面' }}</span>
                          <!-- <img v-if="ruleForm.idCardPhotoBackend" :src="'data:image/jpeg;base64' + ruleForm.idCardPhotoBackend" style="max-width:100%;max-height:100%;" /> -->
                        </xui-upload>
                    </xui-form-item>
                  </div>
                </div>
              </xui-form>
               <div class="user-center__id-submit">
                  <xui-button type="primary" class="user-center__id-button--bottom" @click="onSubmit('ruleForm')">
                      <span> 提交 </span>
                    </xui-button>
                </div>
            </div>
          </div>
        </user-center-content-slot>
    </user-center-container-slot>
    <xui-dialog title="" :close-on-click-modal="false" showcenter :visible.sync="delWarnning" width="30%">
      <p class="dialog-content">
        <span>
          <template v-if="success">
            <img class="img-status" src="../../../images/settingSuccess.jpg" />
          </template>
          <template v-else>
            <img class="img-status" src="../../../images/settingError.png" />
          </template>
        </span>
      </p>
      <p class="dialog-content">
        <span>
          {{ success ? '您的个人资料保存成功！' : '您的个人资料保存失败！！' }}
        </span>
      </p>
    </xui-dialog>
    <!-- 荣耀安全应急响应中心服务条款弹框 -->
    <xui-dialog title="" class="warnning-wrap" :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" :width="$store.state.isMobile ? '80%': '30%'" :before-close="handleClose">
      <h3 :style="{'font-size': $store.state.isMobile ? '24px': '16.5px'}">荣耀安全应急响应中心服务条款</h3>
      <div class="content-wrap" :style="{'font-size': $store.state.isMobile ? '22px': '14px'}">
        <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
        <ul>
          <li>真实姓名，身份证正反面照片及身份证号；</li>
          <li>银行卡号，开户行信息，银行名称；</li>
          <li>手机号码，邮寄地址；</li>
          <li>昵称，头像，邮箱，主页；</li>
          <li>QQ，微信，签名，团队；</li>
          <li>IP地址；</li>
          <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
        </ul>
        <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
        <span
          >点击“同意”，即表示您同意
          <a :href="safetyURL" target="_blank" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
          ，并知悉
          <a :href="privacyURL" target="_blank" class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span
        >
      </div>
      <span slot="footer" class="dialog-footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>
    <!-- 登录提示弹框 -->
    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>
  </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu'
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot'
import UserCenterSlot from '../../../components/pages/UserCenterSlot'
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot'
import UserCenterContentTitle from '../../../components/pages/UserCenterContentTitle'
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import { mapState } from 'vuex';
import store from '../../../store/index'

export default {
  name: 'usercenterIdInfo',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
    UserCenterContentTitle
  },
  data() {
    return {
      safetyURL: '',
      privacyURL: '',
      editFlag: true,
      isEffect: false,
      isNotLogin: false,
      dialogVisible: false,
      isEdit: true,
      xCsrfToken: null,
      fontUid: '',
      BackendUid: '',
      ruleForm: {
        idCardFrontId: '',
        idCardBackId: '',
        idCardPhoto: {
          font: '',
          backend: ''
        }
      },
      // ruleForm: {
      //   realName: '188sdfsaf',
      //   phoneNumber: '1882***6',
      //   idCard: '4113***1232818',
      //   bank: '中国银行',
      //   bankName: '中国银行深圳支行',
      //   bankCard: '633*888888889',
      // },
      rules: {
        realName: [
          { required: true, message: '请输入有效的名字', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { min: 0, max: 40, message: '最大输入长度40', trigger: 'change' }
        ],
        phoneNumber: [
          {
            required: true,
            message: '请输入有效的手机号码',
            trigger: 'change'
          },
          {
            validator: function(rule, value, callback) {
              if (/^[0-9]*$/.test(value) == false) {
                callback(new Error('请输入有效的手机号码'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        idCard: [
          {
            required: true,
            message: '请输入有效的身份证号码',
            trigger: 'change'
          },
          {
            validator: function(rule, value, callback) {
              const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              const _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;

              if (!(_IDRe18.test(value) || _IDre15.test(value))) {
                callback(new Error('请输入正确的身份证号码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        bank: [
          { required: true, message: '请输入有效的银行名称', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { min: 0, max: 60, message: '最大输入长度60', trigger: 'change' }
        ],
        bankName: [
          { required: true, message: '请输入有效的开户银行', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/g.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { min: 0, max: 60, message: '最大输入长度60', trigger: 'change' }
        ],
        // 银行卡匹配10-30位数字
        bankCard: [
          { min: 10, max: 30, message: '输入长度为10-30的数字', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/^[0-9]*$/.test(value) == false) {
                callback(new Error('请输入有效的银行卡号码'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { required: true, message: '请输入有效的银行卡号码', trigger: 'change' }
        ],
        idCardFrontId: [
          {
            validator: function(rule, value, callback) {
              if (value === '') {
                callback(new Error('上传身份证人像面照片'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        idCardBackId: [
          {
            validator: function(rule, value, callback) {
              if (value === '') {
                callback(new Error('上传身份证国徽面照片'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        idCardPhot: [
          {
            validator: function(rule, value, callback) {
              if (value.font === '' && value.backend === '') {
                callback(new Error('上传身份证照片'));
              } else if (value.font === '') {
                callback(new Error('上传身份证人像面照片'));
              } else if (value.backend === '') {
                callback(new Error('上传身份证国徽面照片'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },
      delWarnning: false,
      success: true
    };
  },
  mounted() {
    this.safetyURL = window.sessionStorage.getItem('safetyURL');
    this.privacyURL = window.sessionStorage.getItem('privacyURL');
    this.getUserInfo();
  },
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  methods: {
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    //限制输入特殊字符
    // btKeyDownPhone: function(e) {
    //   this.ruleForm.phoneNumber = e.target.value.replace(/[`~!@#$%^&()_=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&（）——={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownIdCard: function(e) {
    //   this.ruleForm.idCard = e.target.value.replace(/[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownBankCard: function(e) {
    //   this.ruleForm.bankCard = e.target.value.replace(/[`~!@#$%^&()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownRealName: function(e) {
    //   this.ruleForm.realName = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownBank: function(e) {
    //   this.ruleForm.bank = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownbankName: function(e) {
    //   this.ruleForm.bankName = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // 查询身份认证信息
    getUserInfo: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            console.log(res); //获取数据
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res.data && res.data.status === 200) {
              if (res.data.data.idCardFrontId === null) {
                res.data.data.idCardFrontId = '';
              }
              if (res.data.data.idCardBackId === null) {
                res.data.data.idCardBackId = '';
              }
              global.userInfo = res.data.data;
              global.userInfo.displayName = res.data.data.displayName;
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              global.this_idInfo = this;
              this.ruleForm = res.data.data || {};

              this.originForm = Object.assign({}, global.userInfo);
              // 登陆状态时，获取CSRF
              this.getCSRF();
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    },
    reportError(err) {
      // const callError = JSON.parse(err.message);
      this.$message.error('上传身份证图像失败');
    },
    beforUploadPic(file) {
      const testmsg = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();
      const extension = testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'gif';
      const isList10M = file.size / 1024 / 1024 < 2;
      let bool = false;

      if (extension) {
        bool = true;
      } else {
        bool = false;
      }

      if (!extension) {
        this.$message.warning('上传文件只能是jpg,jpeg,png,gif格式');
      }
      if (!isList10M) {
        this.$message.warning('上传文件大小不能超过2M!');
      }
      return bool && isList10M;
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
          .then(res => {
            window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
            this.xCsrfToken = { 'x-csrf-token': res['headers']['x-csrf-token'] };
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    //点击修改按钮
    onSubmit: function(form) {
      const that = this;
      const params = that.objNotEqual(that.originForm, that.ruleForm);
      if (params.idCardFrontId) {
        delete params.idCardFrontId;
      } else if (params.idCardFrontId !== '' && this.ruleForm.idCardFrontId !== '') {
        this.rules.idCardFrontId[0].validator = null;
      }
      if (params.idCardBackId) {
        delete params.idCardBackId;
      } else if (params.idCardBackId !== '' && this.ruleForm.idCardBackId !== '') {
        this.rules.idCardBackId[0].validator = null;
      }
      // 如果三项有修改，则增加对应的校验
      if (params.phoneNumber) {
        this.rules.phoneNumber[0].pattern = /^(.{1})\d{10,20}$/;
      } else {
        this.rules.phoneNumber[1].validator = null;
      }
      if (params.idCard) {
        this.rules.idCard[0].pattern =
          /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/ || /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      } else {
        this.rules.idCard[1].validator = null;
      }
      if (params.bankCard) {
        this.rules.bankCard[0].pattern = /^([1-9]{1})(\d{9,29})$/;
      } else {
        this.rules.bankCard[1].validator = null;
      }
      this.$refs[form].validate(function(valid) {
        if (valid) {
          const aLen = Object.keys(params).length;
          if (aLen === 0) {
            if (that.fontUid || that.BackendUid) {
              that.delWarnning = true;
              that.success = true;
              that.getUserInfo();
              that.isEdit = false;
              setTimeout(() => {
                window.location.reload();
              }, 50);
            } else {
              console.log('未作修改');
            }
          } else {
            that.editUserInfo(params);
          }
        } else {
          console.log('error submit!!');
          return true;
        }
      });
    },
    // 修改身份认证资料
    editUserInfo: function(params) {
      const that = this;
      const Token = window.sessionStorage.getItem('x-csrf-token');
      const s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/user/editIdentityInfo', params, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            console.log(res); //获取数据
            if (res.data && res.data.status === 200) {
              that.delWarnning = true;
              that.success = true;
              that.getUserInfo();
              that.isEdit = false;
              setTimeout(() => {
                window.location.reload();
              }, 50);
            } else {
              this.$message.error(res && res.data && res.data.message);
              that.success = false;
            }
            setTimeout(() => {
              that.delWarnning = false;
            }, 2000);
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) {
              this.$message.error(error.response && error.response.data && error.response.data.message);
            }
          });
      });
    },
    // 比较两个对象,取出value不同的
    objNotEqual: (oldParam, newParam) => {
      const c = {};
      for (const key in oldParam) {
        if (oldParam[key] !== newParam[key]) {
          c[key] = newParam[key];
        }
      }
      return c;
    },
    onEdit: function() {
      this.isEdit = false;
      this.editFlag = false;
      // const s = new Promise((resolve, reject) => {
      //   this.$http
      //     .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } }, {})
      //     .then(res => {
      //       // 接口直接返回布尔值，false时为未签名，弹出签名窗
      //       if (!res.data) {
      //         this.dialogVisible = true;
      //       } else {
      //         // 为true时，为签名验证已过，不需要签名
      //         this.isEdit = false;
      //         this.editFlag = false;
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error);
      //     });
      // });
    },
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
              this.isEdit = false;
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    mockRequest(param, onProgress) {
      return new Promise((resolve, reject) => {
        const event = {
          total: 3000,
          loaded: 0
        };
        const timer = setInterval(() => {
          event.loaded += 500;
          if (onProgress && typeof onProgress === 'function') {
            onProgress(event);
          }
          if (event.loaded >= event.total) {
            clearInterval(timer);
            resolve('success');
          }
        }, 200);
      });
    },
    uploadImg(params) {
      const type = params.action;
      let imgUrl = '';
      // Promise的数据需要用.then得到
      this.getBase64(params.file).then(res => {
        imgUrl = res;
        let param;
        if (type === 'idCardFrontId') {
          param = {
            idCardFront: imgUrl
          };
        } else {
          param = {
            idCardBack: imgUrl
          };
        }
        this.$http
          .post('vul/hsrc/vul/report/services/user/editIdentityInfo', param, {
            headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') },
            onUploadProgress: progressEvent => {
              params.file.percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
              params.onProgress(params.file);
            }
          })
          .then(res => {
            console.log(res); //获取数据
            if (res.data && res.data.status === 200) {
              this.ruleForm[type] = String(params.file.uid);
              if (type === 'idCardFrontId') {
                this.$refs.ruleForm.validateField('idCardFrontId');
                this.fontUid = params.file.uid;
              } else {
                this.$refs.ruleForm.validateField('idCardBackId');
                this.BackendUid = params.file.uid;
              }
              params.onSuccess();
            } else {
              this.$message.error(res && res.data && res.data.message);
              this.success = false;
            }
          })
          .catch(error => {
            console.log(error);
            params.onError();
            if (error.response && error.response.data && error.response.data.message) {
              this.$message.error(error.response && error.response.data && error.response.data.message);
            }
          });
      });
    },
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        let imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    handlePreview() {
      // this.ruleForm.idCardPhoto.backend = '../../../images/authentication.png';
    },
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    handleClose: function() {
      this.$router.push({ path: '/' });
    },
    triggerRemove(param) {
      if (param.uid === this.fontUid) {
        this.ruleForm.idCardFrontId = '';
        this.$refs.ruleForm.validateField('idCardFrontId');
      } else {
        this.ruleForm.idCardBackId = '';
        this.$refs.ruleForm.validateField('idCardBackId');
      }
    },
    loginHandleClose: function() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
<style lang="less" scoped>
.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 60px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}

/deep/.dialog-content {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  text-align: center !important;
  font-size: 1rem;
  .img-status {
    width: 6rem;
  }
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}

// 20220812界面改版需求新增
.user-center__id-row{
  display:flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 50px;
  border-bottom: 1px solid var(--src-color-secondary-light5);
}

.user-center__id-summary{
  display: flex;
  align-items: center;
}

.user-center__id-icon--default{
  display: inline-block;
  width: 84px;
  height: 84px;
  line-height: 84px;
  border-radius: 50%;
  font-size: var(--src--text-size-large-extra10);
  background: var(--src-bg-color-dark1);
  text-align: center;
  color: var(--src-text-color-white);
}

.user-center__id-tips{
  margin-left: 15px;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
}

.user-center__id-button--primary{
   width: 82px;
  height: 24px;
  line-height: 24px;
  background: var(--src-bg-color-blue-dark1);
  border-radius: 18px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white);
  text-align: center;
  font-weight: var(--src-text-weight-light1);
}

.user-center__id-tips--friendly{
  padding: 20px 50px 15px;;
  font-size: var(--src--text-size-default);
  color: var(--src-bg-color-red-light2);
}

.user-center__id-list{
  display: flex;
  flex-wrap: wrap;
  padding: 5px 50px 0;
}

.user-center__id-item{
  display: flex;
  align-items: center;
  flex-basis: 50%;
  padding: 0 20px;
  margin-top: 15px;
  font-size: var(--src--text-size-default);
   &.is-overflow-hidden{
    overflow: hidden;
  }
}

.user-center__id-item-title{
  font-size: var(--src--text-size-middle);
  width: 105px;
  margin-right: 10px;
  color: var(--src-color-secondary-light6);
  text-align: right;
  font-weight: var(--src-text-weight-light1);
  &.is-required:before{
    content: '*';
    margin-right: 4px;
    color: var(--src-bg-color-red-light1);
  }
}

.user-center__id-item-content{
  flex: 1;
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
  &.is-overflow-hidden{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.user-center__id-item-content .xui-upload--picture-avatar{
  width: 100%;
}

/deep/.user-center__id-list .xui-form-item {
  margin-bottom: 0;
}

/deep/.user-center__id-list .xui-form-item  .xui-input__inner{
    height: 40px;
    line-height: 40px;
}

.user-center__info-button--bottom{
  height: 36px;
  line-height: 34px;
  margin-top: 30px;
  padding: 0 32px;
  background: var(--src-bg-color-blue-dark1) !important;
  border-radius: 5px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white) !important;
  font-weight: var(--src-text-weight-light1);
}

.user-center__id-submit{
  display: flex;
  justify-content: center;
  padding: 0 50px;
  margin-top: 30px;
}

.user-center__id-button--bottom{
  height: 36px;
  line-height: 34px;
  margin-top: 30px;
  padding: 0 32px;
  background: var(--src-bg-color-blue-dark1) !important;
  border-radius: 5px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white) !important;
  font-weight: var(--src-text-weight-light1);
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/idinfo/usercenterIdInfo.vue